'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@morpho-org/ui-v6/utils';
import { Button } from '@repo/ui';
import { trackActivityModeChanged } from '@/lib/analytics/client/trackers/portfolio';
import type { DashboardActivityMode } from './DashboardActivity';
interface ActivityModeButtonsProps {
  mode: DashboardActivityMode;
  onModeChange: (mode: DashboardActivityMode) => void;
}

// Instant pill toggle (matches the pre-@repo/ui Button, which had no transitions): with
// `transition-all`, the ghost->secondary swap on click animates the border from `currentColor`
// (white in dark) — a white flash. Dark active pill stays flat (no chrome).
const pillClassName = (isActive: boolean) => cn('transition-none', isActive && 'dark:border-transparent dark:bg-secondary dark:shadow-none');
const ActivityModeButtons = t0 => {
  const $ = _c(31);
  const {
    mode,
    onModeChange
  } = t0;
  let t1;
  if ($[0] !== mode || $[1] !== onModeChange) {
    t1 = next => {
      if (next !== mode) {
        trackActivityModeChanged({
          mode: next
        });
      }
      onModeChange(next);
    };
    $[0] = mode;
    $[1] = onModeChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectMode = t1;
  const t2 = mode === "earn" ? "secondary" : "ghost";
  let t3;
  if ($[3] !== selectMode) {
    t3 = () => selectMode("earn");
    $[3] = selectMode;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = mode === "earn";
  let t5;
  if ($[5] !== t4) {
    t5 = pillClassName(t4);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t5) {
    t6 = <Button variant={t2} size="sm" onClick={t3} className={t5}>Vaults</Button>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = mode === "borrow" ? "secondary" : "ghost";
  let t8;
  if ($[11] !== selectMode) {
    t8 = () => selectMode("borrow");
    $[11] = selectMode;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = mode === "borrow";
  let t10;
  if ($[13] !== t9) {
    t10 = pillClassName(t9);
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t7 || $[17] !== t8) {
    t11 = <Button variant={t7} size="sm" onClick={t8} className={t10}>Markets</Button>;
    $[15] = t10;
    $[16] = t7;
    $[17] = t8;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = mode === "liquidation" ? "secondary" : "ghost";
  let t13;
  if ($[19] !== selectMode) {
    t13 = () => selectMode("liquidation");
    $[19] = selectMode;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = mode === "liquidation";
  let t15;
  if ($[21] !== t14) {
    t15 = pillClassName(t14);
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t12 || $[24] !== t13 || $[25] !== t15) {
    t16 = <Button variant={t12} size="sm" onClick={t13} className={t15}>Liquidation</Button>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t11 || $[28] !== t16 || $[29] !== t6) {
    t17 = <div className="gap-2xs flex">{t6}{t11}{t16}</div>;
    $[27] = t11;
    $[28] = t16;
    $[29] = t6;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
};
ActivityModeButtons.displayName = 'ActivityModeButtons';
export default ActivityModeButtons;